__turbopack_context__.v({
  "placeholder": "filter-styles-module-scss-module__WRRliG__placeholder",
  "reset": "filter-styles-module-scss-module__WRRliG__reset",
  "wrapper": "filter-styles-module-scss-module__WRRliG__wrapper",
});
